import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { getGs1CodeForShot } from "../lib/photoData";
import Modal from "components/modal";
import Gs1DropDowns from "./gs1-dropdowns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";

const Gs1Modal = (props) => {
    const { image, wipKey, metadata, changeIEGs1 } = props;
    const [showModal, setShowModal] = useState(false);
    const [savedCodes, setSavedCodes] = useState(null);
    const location = useLocation();
    const isIE = location.pathname.includes("image-editing");

    const editIcon = () => {
        return (
            isIE && (
                <span className="edit-button">
                    <FontAwesomeIcon icon={faPencilAlt} />
                </span>
            )
        );
    };

    const btnText = editIcon() ? editIcon() : metadata ? "Edit GS1 Code" : "Add GS1 Code";

    const loadCodes = async () => {
        if (!metadata) {
            setSavedCodes(null);

            return;
        }

        let response = await getGs1CodeForShot(image.key);

        return setSavedCodes(response);
    };

    const openModal = () => {
        loadCodes();
        setShowModal(true);
    };
    const closeModal = () => {
        setShowModal(false);
    };

    return (
        <>
            <button className="button -text" onClick={openModal}>
                {btnText}
            </button>
            <Modal show={!!showModal} onClose={closeModal}>
                <Gs1DropDowns photo={image} isIE={isIE} changeIEGs1={changeIEGs1} savedCodes={savedCodes} wipKey={wipKey} closeModal={closeModal} />
            </Modal>
        </>
    );
};

export default Gs1Modal;
